var socketKey = '';

export default function(state = socketKey, action) {
  if (action.type.includes('Feathers Update')) {
    state = action.key;
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/socketKey-reducer.js